export default {
  dbh_studio_report_all: '全部',
  dbh_studio_report_general_gaming: '市场分析',
  dbh_studio_report_esports: '游戏分析',
  dbh_studio_report_view: '浏览量',
  dbh_studio_no_data: '暂无数据',
  dbh_studio_no_access_view: '该模块暂未开放，敬请期待。',
  dbh_studio_no_permission_view: '该模块暂无权限，请联系DataBrain组织管理员。',
  dbh_studio_in_game_no_permission_woa: '暂无权限访问该模块，如需申请权限，请企微联系{contact}。',
  dbh_studio_in_game_no_permission_global: '暂无权限访问该模块，如需申请权限，请发送邮件至{contact}。',
  dbh_studio_header_explore: '探索',
  dbh_studio_report_title: "报告精选",
  dbh_studio_report_sub_title: "独家内部洞察与精心筛选的市场报告，专为您的游戏量身定制",
  dbh_studio_hotevent_hot_tooltip: "热门事件：连续三天及以上位于Top3内的事件",
  dbh_studio_hotevent_new_tooltip: "新事件：近30天内首次出现的事件",
  dbh_studio_hotevent_rese_tooltip: "激增事件：较上一天评论数激增80%以及以上的事件",
  dbh_studio_report_filter_sorting: "排序",
  dbh_studio_report_opinion_highlight: "舆情动态",
  dbh_studio_report_bechmark_tips: "点击跳转DataBrain-Benchmark专区模块",
  dbh_studio_opinions_report_gpt_more: "展开",
  dbh_studio_opinions_report_gpt_close: "收起",
  dbh_studio_funcom_down_metrics: '指标',
  dbh_studio_funcom_down_official_accounts_channel: '官号渠道',
  dbh_studio_funcom_down_clear_all: '清空',
  dbh_studio_funcom_down_select_all: '全选',
  dbh_studio_funcom_edit_modal_placeholder: '请输入',
  dbh_studio_funcom_edit_modal_comfirm: '确认',
  dbh_studio_funcom_edit_modal_cancel: '取消',
  dbh_studio_funcom_edit_modal_gpt_title: '修改GPT总结',
  dbh_studio_funcom_edit_modal_success: '修改成功',
  dbh_studio_funcom_edit_modal_failed: '修改失败',
  dbh_studio_funcom_add_modal_success: '新增成功',
  dbh_studio_funcom_add_modal_failed: '新增失败',
  dbh_studio_funcom_delete_modal_success: '删除成功',
  dbh_studio_funcom_delete_modal_failed: '删除失败',
  dbh_studio_funcom_save_modal_highlights_success: '保存成功',
  dbh_studio_funcom_save_modal_highlights_failed: '失败',
  dbh_studio_funcom_send_email: '发送邮件',
  dbh_studio_funcom_send_email_success: '邮件发送成功',
  dbh_studio_funcom_send_email_failed: '邮件发送失败',
  dbh_studio_highlights: '要点',
  dbh_studio_edit_highlights: '编辑要点',
  dbh_studio_add_highlights: '新增要点',
  dbh_studio_add_highlights_1: '新增要点',
  dbh_studio_summary: '执行摘要',
  dbh_studio_action: '操作',
  dbh_studio_input_placeholder: '请输入',
  dbh_studio_select_icon: '选择图标',
  dbh_studio_add_row: '添加一行数据',
  dbh_studio_no_content: "暂无内容",
  dbh_studio_no_content1: "当前无内容",
  dbh_studio_appendix: '附录',
  dbh_studio_add_appendix: '增加附录',
  dbh_studio_add__an_appendix: '增加一条附录',
  dbh_studio_edit_appendix: '编辑附录',
  dbh_studio_edit_insights: '编辑洞察',
  dbh_studio_add__an_insights: '请添加洞察',
  dbh_studio_edit_facts: '编辑详情',
  dbh_studio_add_insights: '新增洞察',
  dbh_presentation_loading_failed: '数据加载失败, ',
  dbh_presentation_click_reload: '点击刷新',
  dbh_download_this_report: '下载此报告',
  dbh_studio_aigallery_report_title: '折扣日历',
  dbh_studio_aigallery_report_edit: 'AI编辑',
  dbh_studio_aigallery_report_download: '下载',
  dbh_studio_aigallery_report_publish: '发布',
  dbh_studio_aigallery_report_toolbar_close: '隐藏工具栏',
  dbh_studio_aigallery_report_publish_to: '发布至',
  dbh_studio_aigallery_report_publish_dashboard: '经分系统',
  dbh_studio_aigallery_report_publish_intelligence: '情报系统',
  dbh_studio_aigallery_report_publish_opinion: '舆情系统',
  dbh_studio_aigallery_report_publish_incomplete: '未完成必填项',
  dbh_studio_aigallery_report_publish_success: '发布成功',
  dbh_studio_aigallery_report_publish_name_en: '菜单英文标题',
  dbh_studio_aigallery_report_publish_name_en_placeholder: '填写报表的英文显示名称',
  dbh_studio_aigallery_report_publish_name_cn: '菜单中文标题',
  dbh_studio_aigallery_report_publish_name_cn_placeholder: '填写报表的中文显示名称',
  dbh_studio_aigallery_report_publish_name_en_error:
    '报表名称限制1-50字符且禁止特殊字符如 < > / ?',
  dbh_studio_aigallery_report_edit_query: '请帮我修改HTML，修改点是：',
  dbh_studio_filter_all: '全部',

  // CasualCompetitors 页面文案
  // 品类Tab选项
  dbh_studio_casual_tab_general: '休闲大盘',
  dbh_studio_casual_tab_iaa: 'IAA',
  dbh_studio_casual_tab_match3: '三消',
  dbh_studio_casual_tab_merge2: '二合',
  dbh_studio_casual_tab_luck_battle: 'Lucky Battle',
  dbh_studio_casual_tab_hybrid_casual: '混变超休闲',
  dbh_studio_casual_tab_simulation: '模拟经营',
  dbh_studio_casual_tab_rpg_idler: '放置RPG/塔防',
  // IAA子品类Tab选项
  dbh_studio_casual_tab_mahjong: '麻将',
  dbh_studio_casual_tab_arrows: 'Arrows',
  dbh_studio_casual_tab_iaa_all: '全部IAA',
  // 二合子品类Tab选项
  dbh_studio_casual_tab_merge2_all: '全部二合',
  dbh_studio_casual_tab_merge2_narrative: '剧情二合',
  // 关注游戏Tab选项
  dbh_studio_casual_key_games_tab_active: '活跃',
  dbh_studio_casual_key_games_tab_income: '收入',
  dbh_studio_casual_key_games_tab_download: '下载',
  // KPI指标 - 月粒度
  dbh_studio_casual_kpi_monthly_avg_dau: '月平均日活跃',
  // KPI指标 - 日粒度
  dbh_studio_casual_kpi_daily_dau: '日活跃',
  // 品类大盘 KPI 卡片标题 - 月粒度
  dbh_studio_casual_category_kpi_monthly_dau: '市场月平均日活跃',
  dbh_studio_casual_category_kpi_monthly_iap: '市场总IAP收入($)',
  dbh_studio_casual_category_kpi_monthly_download: '市场总下载量',
  // 品类大盘 KPI 卡片标题 - 日粒度
  dbh_studio_casual_category_kpi_daily_dau: '市场日活跃',
  dbh_studio_casual_category_kpi_daily_iap: '市场总IAP收入($)',
  dbh_studio_casual_category_kpi_daily_download: '市场总下载量',
  // 头部厂商 KPI 卡片标题 - 月粒度
  dbh_studio_casual_publisher_kpi_monthly_dau: '公司月平均日活跃',
  dbh_studio_casual_publisher_kpi_monthly_iap: '公司总IAP收入($)',
  dbh_studio_casual_publisher_kpi_monthly_download: '公司总下载量',
  // 头部厂商 KPI 卡片标题 - 日粒度
  dbh_studio_casual_publisher_kpi_daily_dau: '公司日活跃',
  dbh_studio_casual_publisher_kpi_daily_iap: '公司总IAP收入($)',
  dbh_studio_casual_publisher_kpi_daily_download: '公司总下载量',
  // 表格列标题
  dbh_studio_casual_col_game_name: '游戏名称',
  dbh_studio_casual_col_monthly_avg_dau: '月平均日活跃',
  dbh_studio_casual_kpi_monthly_iap_revenue: '月IAP收入($)',
  dbh_studio_casual_col_monthly_download: '月下载',
  dbh_studio_casual_col_daily_dau: '日活跃',
  dbh_studio_casual_kpi_daily_iap_revenue: '日IAP收入($)',
  dbh_studio_casual_col_daily_download: '日下载',
  dbh_studio_casual_genre_col_active_ratio: '活跃规模品类占比',
  dbh_studio_casual_company_col_active_ratio: '活跃规模公司占比',
  // 通用
  dbh_studio_casual_ratio: '环比',
  // 模块标题
  dbh_studio_casual_key_games_title: '重点游戏',
  dbh_studio_casual_dark_horse_title: '黑马游戏',
  dbh_studio_casual_top_publishers_title: '发行商榜单',
  // 模块切换
  dbh_studio_casual_top_games: '热门游戏',
  dbh_studio_casual_top_games_bubble: '热门游戏为月流水>10M或人工维护的值得关注游戏，季度更新游戏列表',
  // TODO: 更新Bubble文案
  dbh_studio_casual_rising_games_bubble: '黑马游戏模块',
  dbh_studio_casual_rising_games_bubble_daily_general_casual:
    '包含此页面细分品类的所有黑马游戏，选取活跃和收入突增游戏',
  dbh_studio_casual_rising_games_bubble_daily_iaa_mahjong: '选取该品类下月下载>2M，DoD>5%的游戏',
  dbh_studio_casual_rising_games_bubble_daily_iaa_arrows: '选取该品类下月下载>2M，DoD>5%的游戏',
  dbh_studio_casual_rising_games_bubble_daily_iaa_all: '选取该品类下月下载>2M，DoD>5%的游戏',
  dbh_studio_casual_rising_games_bubble_daily_match_3: '选取该品类下月流水>2M，DoD>5%的游戏',
  dbh_studio_casual_rising_games_bubble_daily_merge_2: '选取该品类下月流水>2M，DoD>5%的游戏',
  dbh_studio_casual_rising_games_bubble_daily_merge_2_narrative: '选取该品类下月流水>2M，DoD>5%的游戏',
  dbh_studio_casual_rising_games_bubble_daily_lucky_battle: '选取该品类下月流水>2M，DoD>5%的游戏',
  dbh_studio_casual_rising_games_bubble_daily_hybrid_casual: '选取该品类下月流水>2M，DoD>5%的游戏',
  dbh_studio_casual_rising_games_bubble_daily_simulation: '选取该品类下月流水>2M，DoD>5%的游戏',
  dbh_studio_casual_rising_games_bubble_daily_rpg_tower_defense: '选取该品类下月流水>2M，DoD>5%的游戏',
  dbh_studio_casual_rising_games_bubble_monthly_general_casual:
    '包含此页面细分品类的所有黑马游戏，选取活跃和收入突增游戏',
  dbh_studio_casual_rising_games_bubble_monthly_iaa_mahjong: '选取该品类下月下载>2M，MoM>20%的游戏',
  dbh_studio_casual_rising_games_bubble_monthly_iaa_arrows: '选取该品类下月下载>2M，MoM>20%的游戏',
  dbh_studio_casual_rising_games_bubble_monthly_iaa_all: '选取该品类下月下载>2M，MoM>20%的游戏',
  dbh_studio_casual_rising_games_bubble_monthly_match_3: '选取该品类下月流水>2M，MoM>30%的游戏',
  dbh_studio_casual_rising_games_bubble_monthly_merge_2: '选取该品类下月流水>2M，MoM>30%的游戏',
  dbh_studio_casual_rising_games_bubble_monthly_merge_2_narrative: '选取该品类下月流水>2M，MoM>30%的游戏',
  dbh_studio_casual_rising_games_bubble_monthly_lucky_battle: '选取该品类下月流水>2M，MoM>30%的游戏',
  dbh_studio_casual_rising_games_bubble_monthly_hybrid_casual: '选取该品类下月流水>2M，MoM>30%的游戏',
  dbh_studio_casual_rising_games_bubble_monthly_simulation: '选取该品类下月流水>2M，MoM>30%的游戏',
  dbh_studio_casual_rising_games_bubble_monthly_rpg_tower_defense: '选取该品类下月流水>2M，MoM>30%的游戏',

  // ==================== 指标解释 Tips ====================
  // 品类大盘 KPI 指标解释 - 月粒度
  dbh_studio_casual_kpi_monthly_avg_dau_tips:
    '指标为该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取平均值。\n' +
    '月平均日活跃的计算方式为：月每日活跃用户数之和除以当月天数。由于活跃用户未去重，结果可能存在偏差。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_kpi_cumulative_monthly_iap_tips:
    '指标为该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '收入已包含应用内购、订阅及付费下载的30%平台分成，不包含IAA（广告）收入。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbi_studio_casual_kpi_cumulative_monthly_iap_tips:
    '指标为该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_kpi_cumulative_monthly_download_tips:
    '指标为该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  // 品类大盘 KPI 指标解释 - 日粒度
  dbh_studio_casual_kpi_daily_dau_tips:
    '指标为该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取平均值。\n' +
    '由于活跃用户未去重，结果可能存在偏差。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_kpi_cumulative_daily_iap_tips:
    '指标为该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '收入已包含应用内购、订阅及付费下载的30%平台分成，不包含IAA（广告）收入。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbi_studio_casual_kpi_cumulative_daily_iap_tips:
    '指标为该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_kpi_cumulative_daily_download_tips:
    '指标为该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  // 重点游戏表格指标解释 - 月粒度
  dbh_studio_casual_keygames_monthly_dau_tips:
    '在所选时间区间内取平均值。\n' +
    '月平均日活跃的计算方式为：月每日活跃用户数之和除以当月天数。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_keygames_monthly_iap_tips:
    '在所选时间区间内取总值。\n' +
    '收入已包含应用内购、订阅及付费下载的30%平台分成，不包含IAA（广告）收入。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbi_studio_casual_keygames_monthly_iap_tips:
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_keygames_monthly_download_tips:
    '在所选时间区间内取总值。\n' + '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_keygames_monthly_active_ratio_tips:
    '在所选筛选条件下，该指标表示某产品的月平均日活跃占品类整体月平均日活跃的比例。',
  // 重点游戏表格指标解释 - 日粒度
  dbh_studio_casual_keygames_daily_dau_tips:
    '在所选时间区间内取平均值。\n' + '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_keygames_daily_iap_tips:
    '在所选时间区间内取总值。\n' +
    '收入已包含应用内购、订阅及付费下载的30%平台分成，不包含IAA（广告）收入。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbi_studio_casual_keygames_daily_iap_tips:
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_keygames_daily_download_tips:
    '在所选时间区间内取总值。\n' + '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_keygames_daily_active_ratio_tips:
    '在所选筛选条件下，该指标表示某产品日活跃占品类整体日活跃的比例。',
  // 头部厂商 KPI 指标解释 - 月粒度
  dbh_studio_casual_publisher_kpi_monthly_dau_tips:
    '指标为该公司该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取平均值。\n' +
    '月平均日活跃的计算方式为：月每日活跃用户数之和除以当月天数。由于活跃用户未去重，结果可能存在偏差。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_publisher_kpi_monthly_iap_tips:
    '指标为该公司该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '收入已包含应用内购、订阅及付费下载的30%平台分成，不包含IAA（广告）收入。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbi_studio_casual_publisher_kpi_monthly_iap_tips:
    '指标为该公司该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_publisher_kpi_monthly_download_tips:
    '指标为该公司该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  // 头部厂商 KPI 指标解释 - 日粒度
  dbh_studio_casual_publisher_kpi_daily_dau_tips:
    '指标为该公司该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取平均值。\n' +
    '由于活跃用户未去重，结果可能存在偏差。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_publisher_kpi_daily_iap_tips:
    '指标为该公司该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '收入已包含应用内购、订阅及付费下载的30%平台分成，不包含IAA（广告）收入。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbi_studio_casual_publisher_kpi_daily_iap_tips:
    '指标为该公司该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_publisher_kpi_daily_download_tips:
    '指标为该公司该品类下所有游戏的指标加总。\n' +
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  // 头部厂商表格指标解释 - 月粒度
  dbh_studio_casual_publisher_table_monthly_dau_tips:
    '在所选时间区间内取平均值。\n' +
    '月平均日活跃的计算方式为：月每日活跃用户数之和除以当月天数。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_publisher_table_monthly_iap_tips:
    '在所选时间区间内取总值。\n' +
    '收入已包含应用内购、订阅及付费下载的30%平台分成，不包含IAA（广告）收入。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbi_studio_casual_publisher_table_monthly_iap_tips:
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_publisher_table_monthly_download_tips:
    '在所选时间区间内取总值。\n' + '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_publisher_table_monthly_active_ratio_tips:
    '在所选筛选条件下，该指标表示某产品的月平均日活跃占公司整体月平均日活跃的比例。',
  // 头部厂商表格指标解释 - 日粒度
  dbh_studio_casual_publisher_table_daily_dau_tips:
    '在所选时间区间内取平均值。\n' + '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_publisher_table_daily_iap_tips:
    '在所选时间区间内取总值。\n' +
    '收入已包含应用内购、订阅及付费下载的30%平台分成，不包含IAA（广告）收入。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbi_studio_casual_publisher_table_daily_iap_tips:
    '在所选时间区间内取总值。\n' +
    '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_publisher_table_daily_download_tips:
    '在所选时间区间内取总值。\n' + '数据仅包含 App Store 和 Google Play 平台，不包含中国安卓等其他第三方平台数据。',
  dbh_studio_casual_publisher_table_daily_active_ratio_tips:
    '在所选筛选条件下，该指标表示某产品日活跃占公司整体日活跃的比例。',
  dbh_studio_fullscreen_enter: '全屏',
  dbh_studio_fullscreen_exit: '退出全屏',
};
